module.exports = __webpack_public_path__ + "img/uk-pneumonia-female.6126d07e.png";